/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconDentalMonitoring/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconDentalMonitoring({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconDentalMonitoring",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 48,
  height = 45,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#B7DDE1",
  fill3 = "#00A3AD",
  fill4 = "#77C5D5"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconDentalMonitoring.Svg"
  data-view-path={viewPath}
 viewBox="0 0 48 45"
 style={{'--as-1-1PBSO0': alignSelf,'--mt-2-1PBSO0': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1PBSO0': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1PBSO0': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1PBSO0': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1PBSO0': opacity,'--w-10-1PBSO0': typeof width === 'number' ? `${width}px` : width,'--h-11-1PBSO0': typeof height === 'number' ? `${height}px` : height,'--f-12-1PBSO0': fill,'--a-7-1PBSO0': isAnimated ? animation : "none",'--sd-8-1PBSO0': isAnimated ? strokeDashoffset : 0,'--sd-9-1PBSO0': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconDentalMonitoring.SvgPath"
  data-view-path={viewPath}
 d="M10.508 17.245c-5.06 2.835-5.06 7.603 0 10.438L38.79 43.79c5.06 2.835 9.211.516 9.211-5.154V6.42c0-5.67-4.151-8.118-9.21-5.155L10.507 17.245z"
 style={{'--f-12-1PBSO0': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconDentalMonitoring.SvgPath:1"
  data-view-path={viewPath}
 d="M37.232 27.81c5.06-2.834 5.06-7.473 0-10.308L9.082 1.523C4.151-1.31 0 1.008 0 6.678v31.957c0 5.67 4.151 7.99 9.081 5.154l28.151-15.978z"
 style={{'--f-12-1PBSO0': fill3}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="TysiaIconDentalMonitoring.SvgPath:2"
  data-view-path={viewPath}
 d="M39.438 26.265a7.553 7.553 0 01-1.946 1.418L24 35.285l3.892 2.191 11.546-11.21z"
 style={{'--f-12-1PBSO0': fill4}}
 className={`views-block ${styles.SvgPath2}`}
/>
</svg>
{children}
</React.Fragment>)
}